import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'StyleTask/Order', method: 'GET', body: null, token: token })
}
